import buttons from './buttons'
import cards from './cards'
import text from './text'
import links from './links'
import layout from './layout'

const theme = {
  breakpoints: ['600px', '960px', '1280px', '1920px'], //needs to be string and include unit value to work with responsive styles
  breakpointValues: [600, 960, 1280], // needs to match breakpoints, for use in js where we just need the value
  space: [0, 4, 8, 12, 16, 24, 32, 48, 80],
  fonts: {
    body:
      'Graphik system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    heading: 'Haptik',
    monospace: 'Menlo, monospace',
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 30, 35, 44, 55, 70, 95],
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },

  colors: {
    black: '#000000',
    background: '#FAFAFA',
    tableRowOdd: '#F3F7FA',
    primary: '#304a3d', //forest
    forest: '#304a3d', //forest
    forestHover: '#586860',
    forestDisabled: '#97A49E',
    sky: '#92D3F3', //sky
    skyHover: '#B3E0F7',
    skyDisabled: '#C8E8F9',
    citron: '#E7F74B', //citron
    citronHover: '#F1FA93',
    citronDisabled: '#8ca145',
    muted: '#8C8987',
    mutedDarker: '#787673',
    white: '#FFFFFF',
    darkGray: '#6F6C69',
    medSilver: '#979491',
    paleBlue: '#E7F1F9',
    paleSilver: '#F5F1ED', //input field background
    inputBackground: '#F5F1ED', //paleSilver
    silver: '#DBD6D1',
    tomato: '#F55D3C',
    sunflower: '#FFC339',
    lavender: '#CFB4FF',
    seaGreen: '#05A58A',
    inputSuccess: '#EBF8F6', //minty
    mint: '#CDEDE8', //minty
    inputError: '#FDDFD8', //pinkish
    gold: '#C1A070',
    forest80: '#596E64',
    forest60: '#83928B',
    forest40: '#ACB7B1',
    forest20: '#D6DBD8',
    lightBlue: '#A3D9F3',
    iconGrey: '#B8BCBF',
    darkDivider: '#C4C4C4',
  },
  text,
  buttons,
  cards,
  links,
  layout,
  forms: {
    input: {
      borderRadius: 0,
      height: 50,
      bg: 'paleSilver',
      border: 'none',
      mb: 4,
    },
    textarea: {
      borderRadius: 0,
      bg: 'paleSilver',
      border: 'none',
      mb: 3,
    },
    select: {
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      MsAppearance: 'none',
      appearance: 'none',
      display: 'flex',
      borderRadius: 0,
      border: 'none',
      height: 50,
      padding: 2,
      pr: 46,
      width: '100%',
      mb: 4,
      textOverflow: 'ellipsis',
    },
    checkbox: {
      '&:checked': {
        bg: 'primary',
      },
    },
  },
  spinner: {
    color: 'primary',
  },
  styles: {
    a: {
      textDecoration: 'none',
    },
    root: {
      fontFamily: 'body',
      lineHeight: 'body',
      fontWeight: 'body',
    },
    hr: {
      color: 'silver',
    },
    select: {
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      MsAppearance: 'none',
      appearance: 'none',
      display: 'flex',
      borderRadius: 0,
      border: 'none',
      height: 50,
      padding: 2,
      pr: 46,
      width: '100%',
      mb: 4,
      textOverflow: 'ellipsis',
    },
  },
  images: {
    cardIcon: {
      width: 24,
      height: 24,
    },
    circle: {
      borderRadius: '50%',
      width: '100%',
      maxWidth: '400px',
      height: '100%',
      maxHeight: '400px',
    },
  },
}

export default theme
